import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable } from 'rxjs';
import { TaskResult } from '../../models/client-models';
import { map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { WebAppSettingsModel } from '../../models/client-models';

const SETTINGS_ENDPOINT = 'settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsBackendService {
  constructor(private http: HttpClient) {}

  public static getSettingsInit(
    idPerson: number,
    apiToken: string
  ): Observable<WebAppSettingsModel> {
    const defaultOptions = {
      headers: {
        Authorization: 'Bearer ' + apiToken,
      },
    };
    return fromPromise(
      fetch(
        AppConfig.settings.backend.url +
          SETTINGS_ENDPOINT +
          '?PersonID=' +
          idPerson,
        { ...defaultOptions }
      )
    ).pipe(
      switchMap((settings) =>
        fromPromise(settings.json()).pipe(
          map((settingsResult: WebAppSettingsModel) => settingsResult)
        )
      )
    );
  }

  /**
   * Get settings from person
   */
  public getSettings(
    idPerson: number,
    admiaUserId: number
  ): Observable<WebAppSettingsModel> {
    return this.http.get<WebAppSettingsModel>(
      AppConfig.settings.backend.url +
        SETTINGS_ENDPOINT +
        '?IDPerson=' +
        idPerson +
        '&IDAdmiaUser=' +
        admiaUserId
    );
  }

  /**
   * Save new Settings.
   *
   * @param newSettings data form from.
   */
  // public setSettings(newSettings: WebAppSettingsModel): Observable<TaskResult> {
  //   return this.http.post<TaskResult>(
  //     AppConfig.settings.backend.url + SETTINGS_ENDPOINT,
  //     newSettings
  //   );
  // }
}
